import { getSessionTheme } from '../../config/themes';

/**
 * Заголовок раздела кабинета. В теме industrial часть `accent` подсвечена жёлтым
 * (двухцветные заголовки, как на слайдах). В исходной теме — один текстовый узел,
 * как было до тем: <mark> разбивает строку на два узла и сдвигает субпиксельное
 * сглаживание глифов, а старые экраны должны остаться пиксель в пиксель.
 */
export default function SectionTitle({ lead, accent }: { lead?: string; accent: string }) {
  const industrial = getSessionTheme() === 'industrial';
  return (
    <h2 className="section-title text-2xl font-bold text-ink mb-1">
      {industrial ? <>{lead && `${lead} `}<mark>{accent}</mark></> : lead ? `${lead} ${accent}` : accent}
    </h2>
  );
}
